"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SegmentIntersector =
/*#__PURE__*/
function () {
  function SegmentIntersector() {
    _classCallCheck(this, SegmentIntersector);

    SegmentIntersector.constructor_.apply(this, arguments);
  }

  _createClass(SegmentIntersector, [{
    key: "isTrivialIntersection",
    value: function isTrivialIntersection(e0, segIndex0, e1, segIndex1) {
      if (e0 === e1) {
        if (this._li.getIntersectionNum() === 1) {
          if (SegmentIntersector.isAdjacentSegments(segIndex0, segIndex1)) return true;

          if (e0.isClosed()) {
            var maxSegIndex = e0.getNumPoints() - 1;

            if (segIndex0 === 0 && segIndex1 === maxSegIndex || segIndex1 === 0 && segIndex0 === maxSegIndex) {
              return true;
            }
          }
        }
      }

      return false;
    }
  }, {
    key: "getProperIntersectionPoint",
    value: function getProperIntersectionPoint() {
      return this._properIntersectionPoint;
    }
  }, {
    key: "setIsDoneIfProperInt",
    value: function setIsDoneIfProperInt(isDoneWhenProperInt) {
      this._isDoneWhenProperInt = isDoneWhenProperInt;
    }
  }, {
    key: "hasProperInteriorIntersection",
    value: function hasProperInteriorIntersection() {
      return this._hasProperInterior;
    }
  }, {
    key: "isBoundaryPointInternal",
    value: function isBoundaryPointInternal(li, bdyNodes) {
      for (var i = bdyNodes.iterator(); i.hasNext();) {
        var node = i.next();
        var pt = node.getCoordinate();
        if (li.isIntersection(pt)) return true;
      }

      return false;
    }
  }, {
    key: "hasProperIntersection",
    value: function hasProperIntersection() {
      return this._hasProper;
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection() {
      return this._hasIntersection;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return this._isDone;
    }
  }, {
    key: "isBoundaryPoint",
    value: function isBoundaryPoint(li, bdyNodes) {
      if (bdyNodes === null) return false;
      if (this.isBoundaryPointInternal(li, bdyNodes[0])) return true;
      if (this.isBoundaryPointInternal(li, bdyNodes[1])) return true;
      return false;
    }
  }, {
    key: "setBoundaryNodes",
    value: function setBoundaryNodes(bdyNodes0, bdyNodes1) {
      this._bdyNodes = new Array(2).fill(null);
      this._bdyNodes[0] = bdyNodes0;
      this._bdyNodes[1] = bdyNodes1;
    }
  }, {
    key: "addIntersections",
    value: function addIntersections(e0, segIndex0, e1, segIndex1) {
      if (e0 === e1 && segIndex0 === segIndex1) return null;
      this.numTests++;
      var p00 = e0.getCoordinates()[segIndex0];
      var p01 = e0.getCoordinates()[segIndex0 + 1];
      var p10 = e1.getCoordinates()[segIndex1];
      var p11 = e1.getCoordinates()[segIndex1 + 1];

      this._li.computeIntersection(p00, p01, p10, p11);

      if (this._li.hasIntersection()) {
        if (this._recordIsolated) {
          e0.setIsolated(false);
          e1.setIsolated(false);
        }

        this._numIntersections++;

        if (!this.isTrivialIntersection(e0, segIndex0, e1, segIndex1)) {
          this._hasIntersection = true;

          if (this._includeProper || !this._li.isProper()) {
            e0.addIntersections(this._li, segIndex0, 0);
            e1.addIntersections(this._li, segIndex1, 1);
          }

          if (this._li.isProper()) {
            this._properIntersectionPoint = this._li.getIntersection(0).copy();
            this._hasProper = true;

            if (this._isDoneWhenProperInt) {
              this._isDone = true;
            }

            if (!this.isBoundaryPoint(this._li, this._bdyNodes)) this._hasProperInterior = true;
          }
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SegmentIntersector;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isAdjacentSegments",
    value: function isAdjacentSegments(i1, i2) {
      return Math.abs(i1 - i2) === 1;
    }
  }]);

  return SegmentIntersector;
}();

exports.default = SegmentIntersector;

SegmentIntersector.constructor_ = function () {
  this._hasIntersection = false;
  this._hasProper = false;
  this._hasProperInterior = false;
  this._properIntersectionPoint = null;
  this._li = null;
  this._includeProper = null;
  this._recordIsolated = null;
  this._isSelfIntersection = null;
  this._numIntersections = 0;
  this.numTests = 0;
  this._bdyNodes = null;
  this._isDone = false;
  this._isDoneWhenProperInt = false;
  var li = arguments[0],
      includeProper = arguments[1],
      recordIsolated = arguments[2];
  this._li = li;
  this._includeProper = includeProper;
  this._recordIsolated = recordIsolated;
};